module.exports = __webpack_public_path__ + "static/media/background.70fbec88.jpg";